import {AfterViewInit, Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {GaugeCircleChartData} from '../../../../models/influencer';
import {TopicSegmentReport} from '../../../../models/measure/topic-segment-report';
import {ReferenceDataService} from '../../../services/reference-data/reference-data.service';
import {PdfExportService} from '../../../services/export-pdf/pdf-export.service';
import {UserService} from '../../../services/user.service';
import {ReportSectionEnum} from '../../../../models/measure/report';

@Component({
  selector: 'topic-drill-down',
  templateUrl: './topic-drill-down.component.html',
  styleUrls: ['./topic-drill-down.component.scss']
})
export class TopicDrillDownComponent implements OnInit, AfterViewInit {
  static COMPONENT_NAME = 'TopicDrillDownComponent';
  @Input()
  topicSegmentReport: TopicSegmentReport;
  @Output() changeSettingEvent: EventEmitter<any> = new EventEmitter<any>();


  public selectedTopics = [];
  private hiddenTopics = [];

  constructor(private pdfService: PdfExportService,
              private userService: UserService) {}

  ngOnInit() {
    const activeTopics = this.allTopics.filter(topic => this.topicSegmentReport.removeTopics.indexOf(topic.name) < 0);
    const allTopicNames = this.allTopics.map(tp => tp.name);
    this.hiddenTopics = this.topicSegmentReport.allTopicCharts.filter(tp => allTopicNames.indexOf(tp.name) < 0 && this.topicSegmentReport.removeTopics.indexOf(tp.name) >= 0)
      .map(topic => topic.name);
    this.selectedTopics = activeTopics.map((topic) => topic.id);
  }

  ngAfterViewInit() {
    this.pdfService.incrementNumberReportReady(TopicDrillDownComponent.COMPONENT_NAME);
  }

  get activeCharts() {
    if (!this.topicSegmentReport) {
      return [];
    }
    const inActiveTopics = this.topicSegmentReport.removeTopics;
    return this.topicSegmentReport.allTopicCharts.filter((topic) => inActiveTopics.indexOf(topic.name) < 0);
  }

  get allTopics() {
    return this.topicSegmentReport ? this.topicSegmentReport.allTopics : [];
  }

  get topicChartColor() {
    return this.userService.chartColors[0];
  }

  filterTopics(evt) {
    const newInActiveTopics = this.allTopics.filter(topic => this.selectedTopics.indexOf(topic.id) < 0);
    this.topicSegmentReport.removeTopics = newInActiveTopics.map(topic => topic.name);
    this.topicSegmentReport.removeTopics.push(...this.hiddenTopics);
    this.changeSettingEvent.emit({
      reportType: ReportSectionEnum.SEGMENTATION_SEGMENT_REPORT,
      value: this.topicSegmentReport.removeTopics
    });
  }

  get isExportingPdfReport() {
    return this.pdfService.exportingPdf;
  }

  get haveNoData() {
    return this.topicSegmentReport && this.activeCharts.length === 0;
  }
}



// WEBPACK FOOTER //
// ./src/app/main/measure/topic-drill-down/topic-drill-down.component.ts